import { render, staticRenderFns } from "./Contatos.vue?vue&type=template&id=4fcd2d1b&scoped=true"
import script from "./Contatos.vue?vue&type=script&lang=js"
export * from "./Contatos.vue?vue&type=script&lang=js"
import style0 from "./Contatos.vue?vue&type=style&index=0&id=4fcd2d1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcd2d1b",
  null
  
)

export default component.exports